import UserMenu from './UserMenu'
import { supabaseAuthToken$} from '../../../../frontend/authStates'
import { useGet, useLoadable } from 'ccstate-react'
import { currentRoute$ } from '../../../../frontend/router/routeRegistry'

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const authToken = useLoadable(supabaseAuthToken$)
  const currentRoute = useGet(currentRoute$)

  // Don't show header on login page
  const hideHeader = currentRoute && currentRoute.path === '/login'

  return (
    <div className="min-h-screen">
      {!hideHeader && authToken.state === 'hasData' && authToken.data && (
        <header className="bg-white shadow-sm border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center">
                <h1 className="text-xl font-semibold text-gray-900">
                  My App
                </h1>
              </div>
              <UserMenu />
            </div>
          </div>
        </header>
      )}
      <main className={hideHeader ? '' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'}>
        {children}
      </main>
    </div>
  )
}

export default Layout